import { OkrKeyResultComment } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

// eslint-disable-next-line import/prefer-default-export
export const setOkrKeyResultCommentList = (keyResultId: number, comments: OkrKeyResultComment[]) => ({
    type: inferLiteral(types.OKR_KEY_RESULT_COMMENT_LIST),
    keyResultId,
    comments,
})
